import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';

import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { HomePageGuardService } from './core/auth/home-page-guard.service';
import { LoggedUserGuard } from './core/auth/logged-user-guard.service';
import { CoreModule } from './core/core.module';
import {
    CertificationTypeListGuard
} from './core/entities/certification-type/certification-type-list.guard';
import {
    NotificationCertificationsGuard
} from './core/entities/document-notifications/certification/guard/notification-certification.guard';
import {
    NotificationPublicHealthRecordsGuard
} from './core/entities/document-notifications/public-health-record/guard/public-health-record.guard';
import {
    PublicHealthRecordTypeListGuard
} from './core/entities/public-health-record-type/public-health-record-type-list.guard';
import { LayoutComponent } from './core/layout/layout.component';
import { LocalizeModule } from './core/localize/localize.module';
import { LoginComponent } from './login/login.component';
import { SharedModule } from './shared/shared.module';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [LoggedUserGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        canActivate: [HomePageGuardService],
        children: []
      },
      {
        path: 'users',
        loadChildren: () => import('./main/main.module').then(m => m.MainModule),
        canActivate: [NotificationCertificationsGuard, NotificationPublicHealthRecordsGuard],
      },
      {
        path: 'admin',
        loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
        canActivate: [NotificationCertificationsGuard, NotificationPublicHealthRecordsGuard],
      },
      {
        path: 'report',
        loadChildren: () => import('./report/report.module').then(m => m.ReportModule),
        canActivate: [NotificationCertificationsGuard, NotificationPublicHealthRecordsGuard],
      },
      {
        path: 'medical-centers',
        loadChildren: () => import('./medical-centers/medical-centers.module').then(m => m.MedicalCentersModule),
        canActivate: [NotificationCertificationsGuard, NotificationPublicHealthRecordsGuard],
      },
      {
        path: 'country-cards',
        loadChildren: () => import('./country-cards/country-cards.module').then(m => m.CountryCardsModule),
        canActivate: [CertificationTypeListGuard, PublicHealthRecordTypeListGuard,
          NotificationCertificationsGuard, NotificationPublicHealthRecordsGuard]
      }
    ]
  },

];

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent
  ],
  imports: [
    // angular
    BrowserModule,
    BrowserAnimationsModule,

    // core & shared
    CoreModule,
    SharedModule,

    RouterModule.forRoot(routes, {
      enableTracing: environment.routerTrace
    }),

    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    LocalizeModule.forRoot({
      fallbackCulture: 'it-IT',
      jsonPath: '/assets/i18n/',
    }),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {

}
